export default __webpack_public_path__ + "static/media/regulatory--end-of-cycling-restriction--g1.7b7df3dd.png";